module.exports = __webpack_public_path__ + "img/symbol_9.ce06994a.png";